export const SET_VENDORLOCATIONS = 'SET_VENDORLOCATIONS';
export const GET_VENDORLOCATIONS = 'GET_VENDORLOCATIONS';
